import { GetFlightGroupResponse, PostFlightAutoType } from '@orbit/api-types'
import { getDeviceContext } from '@lib/analytics'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useCreateFlightAuto = () => {
	const queryClient = useQueryClient()

	return useMutation<GetFlightGroupResponse, Error, { tripId: string; data: PostFlightAutoType }>({
		mutationFn: async ({ tripId, data }) => {
			const response = await api.post<GetFlightGroupResponse>(`/trips/${tripId}/flights/auto`, { ...data, analytics: getDeviceContext() })
			return response.data
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.flights(variables.tripId) })
		},
	})
}
